import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  title: css`
    text-align: center;
    text-transform: capitalize;
  `,
  modalTitleContainer: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${colors.white};
    padding: 24px 0px 20px 0px;
    border-bottom: 1px solid ${colors.silver};
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  `,
  container: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    background-color: ${colors.white};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    max-height: 80vh;
  `,
  backButtonPosition: css`
    position: absolute;
    left: 8px;
  `,
  footer: css`
    padding: 24px 24px 32px 24px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${colors.silver};
  `,
  closeButton: css`
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 24px;
    color: ${colors.prussian};
  `,
  content: css`
    padding: 24px;
    overflow-y: auto;
    flex-grow: 1;
  `,
};

export default styles;
